import { newhopeAPIService } from './index'

const route = 'pre-deal-posts'

export default {
  list() {
    return newhopeAPIService({
      url: route,
      method: 'get',
    })
  },
  load(id) {
    return newhopeAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  delete(id) {
    return newhopeAPIService({
      url: `${route}/${id}`,
      method: 'delete',
    })
  },
}
